import { css } from '@emotion/react';
import { red, orange, yellow, green } from '@mui/material/colors';

import { AppState } from '../@types/State';
import { intelColors } from '../Constants';
import { parseState, STORAGE_KEY } from '../context/AppState';

const mode = parseState(localStorage.getItem(STORAGE_KEY)).darkMode
  ? 'dark'
  : 'light';

export function getColorFromAge(age: number | undefined | null) {
  if (!age) {
    return 'inherit';
  } else if (age < 3600) {
    return intelColors[mode].freshest;
  } else if (age < 14400) {
    return intelColors[mode].fresh;
  } else if (age < 28800) {
    return intelColors[mode].older;
  } else {
    return intelColors[mode].oldest;
  }
}

export function getColorFromCooldownTicks(age: number) {
  if (age === 0) {
    return intelColors[mode].freshest;
  } else if (age < 2) {
    return intelColors[mode].fresh;
  } else if (age < 4) {
    return intelColors[mode].older;
  } else {
    return intelColors[mode].oldest;
  }
}

export function getColorFromTicks(ticks: number) {
  if (isNaN(ticks)) {
    return '#B0BECF'; // Default color for invalid ticks
  }
  if (ticks < 2) {
    return intelColors[mode].oldest;
  } else if (ticks >= 2 && ticks < 6) {
    return intelColors[mode].older;
  } else if (ticks >= 6 && ticks < 10) {
    return intelColors[mode].fresh; // Darker green
  } else {
    return intelColors[mode].freshest; // Light green
  }
}

// export function getColorFromReliability(val: number | undefined) {
//   if (!val) return red[500];
//   if (val == 100) {
//     return green[500];
//   } else if (val > 80) {
//     return yellow[500];
//   } else if (val > 70) {
//     return orange[500];
//   } else {
//     return red[500];
//   }
// }

// export function getColorFromTicksOld(ticks: number) {
//   const persistedState: AppState = parseState(
//     localStorage.getItem(STORAGE_KEY)
//   );
//   const darkMode = persistedState.darkMode;

//   if (isNaN(ticks)) {
//     return '#B0BECF';
//   } else if (ticks > 10) {
//     return green[400];
//   }

//   // Normalize ticks to a percentage (0–10)
//   const normalizedTicks = Math.min(ticks, 10); // Ensure ticks do not exceed 10
//   const percentage = Math.round((1 - normalizedTicks / 10) * 100);
//   const hue = ((1 - percentage / 100) * 120).toString(10);

//   // Adjust lightness and saturation based on darkMode
//   const lightness = darkMode ? '50%' : '70%'; // Darker for dark mode, lighter for light mode
//   const saturation = darkMode ? '100%' : '80%'; // Full saturation for dark mode, reduced for light mode

//   const cssValue = ['hsl(', hue, ',', saturation, ',', lightness, ')'].join('');
//   console.log(cssValue);
//   return cssValue;
// }
